<template>
  <div>
    <!-- AppHeaderNew -->
    <AppHeaderNew />

    <section class="error-image">
      <img src="../../assets/error/404error.png" alt />
    </section>

    <!-- FooterNew -->
    <AppFooterNew />
  </div>
</template>

<script type="text/javascript">
import AppHeaderNew from "./HeaderNew.vue";
import AppFooterNew from "./FooterNew.vue";

export default {
  name: "contactPageNew",
  components: {
    AppHeaderNew,
    AppFooterNew,
  },
  data() {
    return {
      //
    };
  },
};
</script>